import { render } from "./side-list-item.vue?vue&type=template&id=868bac32&scoped=true&ts=true"
import script from "./side-list-item.vue?vue&type=script&lang=ts"
export * from "./side-list-item.vue?vue&type=script&lang=ts"

import "./side-list-item.vue?vue&type=style&index=0&id=868bac32&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868bac32"]])

export default __exports__